import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
// material-ui icons
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ModalPregunta from "components/Generales/ModalPregunta";
import ModalAgregarElementosDiseno from './AgregarElementoDiseno';
import Globales from "utils/Globales";
import { Edit, Close, AddCircle, Search, Clear, Filter9Plus } from "@material-ui/icons";
import ReactLoading from "react-loading";

class MateriaPrima extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: '',
      NombreElemento: '',
      idCategoria: '',
      ImagenBase: '',
      Visibilidad: '',
      elementosDisenos: [],
      RutaImagen:"",
      categoriasElementosDisenos: [],
      mensaje: '',
      br: false,
      colorNotificacion: 'success',
      errorNombre: false,
      errorDescripcion: false,
      errorImagenBase: false,
      errorVisibilidad: false,
      elementosDisenoMostrar: [],
      entroFiltrar: false,
      notificacion: false
    };
    //Variable global para indicar el total de registros que se obtendra de la base de datos
    global.Fin = 5;
    global.entrar = true;
    global.response = null;
    this.eventoModalEliminar = this.eventoModalEliminar.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.eliminarElementosDiseno = this.eliminarElementosDiseno.bind(this);
    this.filtrarElementosDiseno = this.filtrarElementosDiseno.bind(this);
    this.seleccionado = {};
  }

  componentDidMount() {
    this.obtenerElementosDisenoFin();
    this.obtenerSchemas();
  }

  //Obtener todos los registros guardados
  obtenerSchemas() {
    fetch(Globales.Url + 'ElementosDiseno/ElementosDiseno/', {
      method: 'GET',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
    })
      .then(res => res.json())
      .then(data => {
      //console.log("TCL: MateriaPrima -> obtenerSchemas -> data", data)
        if (data.error) { //Error al obtener los registros
          this.setState({ elementosDisenos: [] });
        } else { //Obtuvo los registros correctamente
          if(data.data != null){
            this.setState({ elementosDisenos: data.data });
          }else{
            this.setState({ elementosDisenos: [] });
          }
        }
      });

    //Obtener categoría de elementos de diseño
    fetch(Globales.Url + 'ElementosDiseno/CategoriaElementosDiseno/', {
      method: 'GET',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
    })
      .then(res => res.json())
      .then(data => {

        if (data.error) {
          this.setState({ categoriasElementosDisenos: [] });
        } else {
          if(data.data != null){
            this.setState({ categoriasElementosDisenos: data.data });
          }else{
            this.setState({ categoriasElementosDisenos: [] });
          }
        }
      });
  }

  //Obtener el total de registros que se indican
  obtenerElementosDisenoFin() {
    fetch(Globales.Url + 'ElementosDiseno/ElementosDiseno/ListaElementosDiseno', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ Fin: global.Fin })
    }
    ).then(res => {
      global.response = res.status;
      res.json()
        .then(data => {
          if (data.error) { //Error al obtener los registros
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else { //xObtuvo los registros correctamente
            //console.log("-------------",data.mensaje)
            if(data.mensaje != null){
              this.setState({ elementosDisenoMostrar: data.mensaje });
            }else{
              this.setState({ elementosDisenoMostrar: [] });
            }
          }
        })
        .catch(err => console.error(err));
    });
  }

  //Obteniendo el nombre de la categoria de medida
  obtenerNombreCategoriaElementos(idCategoria) {
    var nombre = "";
    this.state.categoriasElementosDisenos.map(categoria => {
      if (categoria._id === idCategoria) {
        nombre = categoria.NombreCategoria
      }
    });
    return nombre;
  }

  //Función de editar registro
  editarElementosDiseno(id, Nombre, idCategoria, Visibilidad,RutaImagen) {
    //console.log(RutaImagen)
    this.setState({ _id: id, NombreElemento: Nombre, idCategoria: idCategoria, Visibilidad: Visibilidad, op: 1, showAgregar: true, Titulo: "Editar Elemento de Diseño",RutaImagen:RutaImagen });
  }

  //Función de eliminar registro
  eliminarElementosDiseno(id) {
    fetch(Globales.Url + 'ElementosDiseno/ElementosDiseno/BajaElementosDiseno', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ _id: id })
    }
    ).then(res => res.json())
      .then(data => {
        if (data.error) {//Error al obtener los registros
          this.setState({ colorNotificacion: 'danger' });
        } else {//Obtuvo los registros correctamente
          this.setState({ colorNotificacion: 'success' });
        }
        this.setState({ mensaje: data.mensaje, show: false });
        this.limpiar();
        this.showNotification();
      });
  }

  //Función para el evento de eliminar
  deleteEvent = (values) => {
    this.seleccionado = values;
    this.setState({ show: true });
  }

  //Función para habilitar el modal de eliminar
  eventoModalEliminar(e) {
    if (!e) {
      this.setState({ show: false });
      return;
    }
    //Eliminar el elemento
    this.eliminarElementosDiseno(this.seleccionado);
  }

  //Función para abrir el modal de agregar registro
  openModalAgregarElementosDiseno = () => {
    this.setState({ showAgregar: true, Titulo: "Nuevo Elemento de Diseño", op: 0 });
  }

  //Función que recupera valores para el modal de agregar
  eventoModalElementosDiseno = (mensaje, colorNotificacion) => {
    //Cambiar valores por default
    this.setState({ showAgregar: false, Titulo: "Nuevo Elemento de Diseño", NombreElemento: "", idCategoria: "", Visibilidad: "", op: 0 })
    this.limpiar();
    //Validar que el mensaje venga diferente de vacio
    if (mensaje !== 'esc') {
      this.setState({ mensaje: mensaje, colorNotificacion: colorNotificacion })
      this.showNotification();
    }
  }

  //Función que habilita la notificación
  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false, notificacion: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  //Función para obtener el texto de los inputs
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  //Función para realizar el filtrado de búsqueda
  filtrarElementosDiseno() {
    var valor1 = 0;
    //Validar que el input no este vacio
    if (this.state.NombreElemento.trim() === '') {
      this.setState({ errorNombre: true, colorNotificacion: 'danger', mensaje: "Complete el campo de búsqueda", NombreElemento: '' });
      valor1 = 1;
    } else {
      this.setState({ errorNombre: false });
      valor1 = 0;
    }
    //Validar si hay campos requeridos
    if (valor1 > 0) { //Hay campos requeridos
      this.showNotification();
    } else { //No hay campos requeridos
      fetch(Globales.Url + 'ElementosDiseno/ElementosDiseno/FiltrarElementoDiseno', {
        method: 'POST',
        headers: {
          Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
        }
        , body: JSON.stringify(this.state)
      }
      ).then(res => res.json())
        .then(data => {
          if (data.error) { //Error en la respuesta
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else if (data.mensaje.length === 0) { //Ninguna coincidencia
            this.setState({ colorNotificacion: "warning",elementosDisenoMostrar:[], mensaje: "No hay ninguna coincidencia", entroFiltrar: true })
            this.showNotification();
          } else { //Filtrado exitoso
            this.setState({ colorNotificacion: 'success', elementosDisenoMostrar: data.mensaje, entroFiltrar: true })
          }
        })
        .catch(err => console.error(err));
    }
  }

  //Función para volver los valores por default
  limpiar() {
    this.setState({ NombreElemento: '', entroFiltrar: false });
    global.Fin = 5;
    global.entrar = true;
    global.response = null;
    this.obtenerElementosDisenoFin();
    this.obtenerSchemas();
  }

  //Función para mostrar mas registros en la tabla
  verMas() {
    //Validar si entro a filtrar
    if (this.state.entroFiltrar) {
      this.limpiar();
    } else {
      //Creando variable con mas valor que la variable global
      var num = global.Fin + 5;
      //Validación de el valor de la variable global sea menor o igual que el total de registros obtenidos
      if (num <= this.state.elementosDisenos.length && global.entrar) {
        //Cambiando el valor de la variable global
        global.Fin = num;
        //Obteniendo el número de registros requeridos
        this.obtenerElementosDisenoFin();
      };
      //Validación de que el número total de registros requiridos sea mayor al total de registros y cambio de valor de variables
      if (num > this.state.elementosDisenos.length && global.entrar) {
        //Cambiando el valor de la variable para que no vuelva a traer mas registros
        global.entrar = false;
        //Cambiando el valor de la variable global
        global.Fin = this.state.elementosDisenos.length;
        //Obteniendo el total de los registros requeridos
        this.obtenerElementosDisenoFin();
      };
      //Validación de que ya no hay mas registros que mostrar
      if (!global.entrar) {
        this.setState({ mensaje: 'No hay más elementos de diseño para mostrar', colorNotificacion: 'warning' });
        this.showNotification();
      };
    }
  }

  render() {
    let agregar;
    if (this.state.showAgregar === true) {
      agregar =
        <ModalAgregarElementosDiseno
          Titulo={this.state.Titulo}
          NombreElemento={this.state.NombreElemento}
          idCategoria={this.state.idCategoria}
          Visibilidad={this.state.Visibilidad}
          CategoriaElementos={this.state.categoriasElementosDisenos}
          _id={this.state._id}
          showAgregar={this.state.showAgregar}
          eventClick={this.eventoModalElementosDiseno}
          op={this.state.op}
          classes={this.props}
          RutaImagen={this.state.RutaImagen}
        />
    }
    const { classes } = this.props;
    return (
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info" text>
                <h4 className={classes.cardTitle}>Elementos de Diseño</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Buscar elemento"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        onChange: this.handleChange,
                        value: this.state.NombreElemento,
                        name: "NombreElemento",
                        id: "NombreElemento",
                        type: "text",
                        error: this.state.errorNombre
                      }}
                      className="mt-5"
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Button size="sm" type="submit" className="pull-left mt-5" color="info" round onClick={() => this.filtrarElementosDiseno()}><Search />Buscar</Button>
                    <Button size="sm" type="submit" className="pull-left mt-5" color="danger" round onClick={() => this.limpiar()}><Clear />Limpiar</Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="info" round onClick={() => this.verMas()}><Filter9Plus />Ver Más</Button>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="success" round onClick={() => this.openModalAgregarElementosDiseno()}><AddCircle />Agregar</Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          {/* Tabla de elementosDisenos */}
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info">
                <GridContainer>
                  <GridItem xs={12} sm={12} md={7}>
                    <h4 className="pull-left">Lista de Elementos de Diseño</h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                {global.response === 200 ?
                  <div className="table-wrapper-scroll-y">
                    <table className="col-xs-12 col-sm-12 col-md-12">
                      <thead>
                        <th className="center">Nombre</th>
                        <th className="center">Categoria</th>
                        <th className="center">Visibilidad</th>
                        <th className="pull-right">Acciones</th>
                      </thead>
                      <tbody>
                        {this.state.elementosDisenoMostrar.map(elemento => {
                          return (
                            <tr key={elemento._id}>
                              <td>{elemento.NombreElemento}</td>
                              <td>{this.obtenerNombreCategoriaElementos(elemento.idCategoria)}</td>
                              <td>{elemento.Visibilidad}</td>
                              <td className="pull-right">
                                <Button color="warning" round justIcon size="sm" onClick={() => this.editarElementosDiseno(elemento._id, elemento.NombreElemento, elemento.idCategoria, elemento.Visibilidad,elemento.RutaImagen)}><Edit /></Button>
                                <Button color="danger" round justIcon size="sm" onClick={() => this.deleteEvent(elemento._id)}><Close /></Button>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div> :
                  <GridContainer justify='center'>
                    <ReactLoading type={'bubbles'} color={'#CFCFCF'} height={'10%'} width={'10%'} />
                  </GridContainer>
                }
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <div id="">
          <ModalPregunta
            Titulo={"Eliminar Elemento de Diseño"}
            Cuerpo={"¿Está seguro que desea eliminar el elemento de diseño?"}
            show={this.state.show}
            eventClick={this.eventoModalEliminar}
          />
          {agregar}
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    )
  }
}

export default withStyles(headerLinksStyle)(MateriaPrima);